import styled from 'styled-components'

const GlobalStyles = styled.div`
  @import url("https://use.typekit.net/hzr5brx.css");

  font-family: ${props => props.theme.fontFamily};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-top: 20px;
  width: 100vw;
  height: 100vh;
  background-color: #f5f5f5; 
`

export default GlobalStyles
